<template>
  <b-card>
    <layout-loading v-if="itemLoading" />
    <b-form v-if="render && permissions">
      <b-row>
        <b-col md="6">
          <b-form-group
            :label="$t('general.roleName')"
            label-for="role-roleName"
          >
            <b-form-input
              id="role-roleName"
              v-model="form.roleName"
              :state="validateState('roleName')"
              aria-describedby="input-roleName-feedback"
            />
            <b-form-invalid
              id="input-roleName-feedback"
              :label="$t('general.roleName')"
              :validator="$v.form.roleName"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <h3 class="text-center">
            {{ $t('permissions.list') }}
          </h3>
          <hr>
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th>{{ $t('general.row') }}</th>
                <th>{{ $t('permissions.resource') }}</th>
                <th colspan="7">
                  {{ $t('general.permissions') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(resource,index) in Object.keys(permissions)"
                :key="index"
              >
                <td>{{ ++index }}</td>
                <td>{{ $t(`permissions.${resource}`) }}</td>
                <td
                  v-for="permission in permissions[resource]"
                  :key="permission"
                >
                  <span>{{ $t(`permissions.${permission}`) }} </span>
                  <b-form-checkbox
                    id=""
                    v-model="new_permissions"
                    :value="resource + '/' + permission"
                    name="check-button"
                    class="ml-1"
                    switch
                    inline
                  />
                </td>
              </tr>
            </tbody>

          </table>
        </b-col>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ isSubmit ? $t("general.isSubmit") : $t("general.update") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="$router.go(-1)"
          >
            {{ $t("general.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>

</template>

<script>
import {
  BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BFormCheckbox, BRow,
} from 'bootstrap-vue'
import '@/components/BFileInput/index.vue'
import BFormInvalid from '@/components/BFormInvalid/index.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import Ripple from 'vue-ripple-directive'
import { required, minLength } from 'vuelidate/lib/validators'
import useRolesList from './useRolesList'

export default {
  name: 'RoleAdd',
  components: {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormInvalid,
    BRow,
    LayoutLoading,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      new_permissions: [],
    }
  },
  validations: {
    form: {
      roleName: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    itemId() {
      return this.$router.currentRoute.params.id
    },
    render() {
      return this.item ? this.item && Object.keys(this.item).length : true
    },
  },
  created() {
    this.fetchPermissions()
  },
  methods: {
    validateState(name) {
      const {
        $dirty,
        $error,
      } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    submitForm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      const data = {
        roleName: this.form.roleName,
        permissions: this.new_permissions,
      }
      this.addItem(data)
    },
  },
  setup() {
    const {
      addItem,
      fetchItem,
      fetchPermissions,
      form,
      handleUpload,
      isSubmit,
      item,
      itemLoading,
      permissions,
      updateItem,
    } = useRolesList()
    return {
      addItem,
      fetchItem,
      fetchPermissions,
      form,
      handleUpload,
      isSubmit,
      item,
      itemLoading,
      permissions,
      updateItem,
    }
  },
}
</script>
